import React from 'react';
import TextField from 'material-ui/TextField';
import cx from 'classnames';

const containerStyles = {
  width: '100%',
  verticalAlign: 'middle'
};

const textFieldStyles = {
  underlineShow: false,
  errorStyle: {
    color: 'rgb(244, 67, 54) !important',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    position: 'absolute',
    transform: 'translateY(26px)'
  },
  floatingLabelStyle: {
    maxWidth: '100%',
    whiteSpace: 'nowrap'
  }
};

export default function CustomTextField(props) {

  const onBlur = (event) => {
    if (props.onBlur) {
      props.onBlur(event, event.target.value);
    }
  };

  const onChange = (event, value) => {
    if (props.onChange) {
      props.onChange(event, value || event.target.value);
    }
  };

  return (
    <div className={cx('text-field-container', 'clearfix', (props.errorText && 'error'))}
      style={{...containerStyles, ...(props.style || {})}}>
      <TextField
        {...textFieldStyles}
        {...props}
        className='text-field'
        onBlur={onBlur}
        onChange={onChange}
      />
    </div>
  );

}



// WEBPACK FOOTER //
// ./shared/common/components/TextField.js